const accountingAccountTransferStatusForSelection = ['Created', 'Pending', 'Done', 'Cancelled'].map(key => {
	return { id: key, name: key };
});
export { accountingAccountTransferStatusForSelection };
